export default __webpack_public_path__ + "static/media/etsy-logo.25d85e71.svg";